import { setRefreshStatus, updateSharePointLinkUrl } from '../actions/internalActions';
import getSharingLink from '../selectors/getSharingLink';
import { createSharingLink } from '../services/createSharingLink';
import SharingLinkInfo from '../store/schema/SharingLinkInfo';
import { LinkActionStatus } from '../types/LinkActionStatus';
import { logUsage } from 'owa-analytics';
import { refreshExpirationDate } from 'owa-sharing-data';
import { isNullOrWhiteSpace } from 'owa-string-utils';
import { orchestrator } from 'satcheljs';

orchestrator(refreshExpirationDate, async actionMessage => {
    if (typeof actionMessage.id === 'string') {
        const sharingLink: SharingLinkInfo = getSharingLink(<string>actionMessage.id);
        if (!!sharingLink) {
            setRefreshStatus(actionMessage.id, LinkActionStatus.refreshing);
            const newLink = await createSharingLink(
                sharingLink.sharingInfo.canonicalUrl,
                sharingLink.permissionLevel
            );
            if (isNullOrWhiteSpace(newLink.Link)) {
                setRefreshStatus(actionMessage.id, LinkActionStatus.refreshFailed);
                logUsage('LinkRefreshLinkFailed');
                return;
            }
            setRefreshStatus(actionMessage.id, LinkActionStatus.refreshSucceeded);
            updateSharePointLinkUrl(
                sharingLink.linkId,
                newLink.Link,
                sharingLink.url,
                newLink.ExpirationDate
            );
        }
    }
});
